'use strict';

var Types = require('./types');
var Statuses = require('./statuses');

module.exports = function (moreInitialState) {

    moreInitialState = moreInitialState || {};

    var initialState = Object.assign({
        status: Statuses.INIT,
        isAuthenticated: false,
        credentials: {},
        artifacts: {},
        error: { // For actual error handling write a separate reducer
            login: false,
            logout: false
        }
    }, moreInitialState);

    return function (state, action) {

        state = state || initialState;

        var type = action.type;
        var payload = action.payload;

        switch (type) {

            case Types.LOGIN_ATTEMPT:
                return Object.assign({}, state, {
                    status: Statuses.WAITING
                });

            case Types.LOGIN_SUCCESS:
                {
                    var error = Object.assign({}, state.error, {
                        login: false
                    });

                    return Object.assign({}, state, {
                        status: Statuses.FINISHED,
                        isAuthenticated: true,
                        credentials: payload.credentials || {},
                        artifacts: payload.artifacts || {},
                        error: error
                    });
                }

            case Types.LOGIN_FAIL:
                {
                    var _error = Object.assign({}, state.error, {
                        login: true
                    });

                    return Object.assign({}, state, {
                        status: Statuses.FINISHED,
                        error: _error
                    });
                }

            case Types.LOGOUT_ATTEMPT:
                return Object.assign({}, state, {
                    status: Statuses.WAITING_LOGOUT,
                    isAuthenticated: false // Immediately considered not authenticated
                });

            case Types.LOGOUT_SUCCESS:
                {
                    // Clear logout error
                    var _error2 = Object.assign({}, state.error, {
                        logout: false
                    });

                    return Object.assign({}, state, {
                        status: Statuses.FINISHED,
                        isAuthenticated: false,
                        credentials: {}, // Only at this point reset credentials/artifacts
                        artifacts: {},
                        error: _error2
                    });
                }

            case Types.LOGOUT_FAIL:
                {
                    // Set logout error
                    var _error3 = Object.assign({}, state.error, {
                        logout: true
                    });

                    return Object.assign({}, state, {
                        status: Statuses.FINISHED,
                        error: _error3
                    });
                }
        }

        return state;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/strange-auth/lib/reducer.js
// module id = 1105
// module chunks = 0